import AuthFlowerPortal from "./AuthFlowerPortal";

export default function Register() {
  return <AuthFlowerPortal initialPanel="register" />;
}
